var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { CaseOneViewSkeleton } from '@/components/pages/case/CaseOneView';
import Layout from '@/container/Layout';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { CaseOnePage } from '@/pages/case/CaseOne/CaseOnePage';
import { useCaseOneFetch } from '@/pages/case/CaseOne/useCaseOneFetch';
import { isGuest, isProfessional } from '@/utils/resources/auth/authResource';
import { caseListPath } from '@/utils/router/links';
/**
 * 案件事例紹介詳細ページ（データ取得, 認証以外のアクセス制限）
 */
export const CaseOne = () => {
    var _a, _b;
    const { id: stringId = '' } = useParams();
    // 選定支援事例ID
    const id = parseInt(stringId, 10);
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { auth } = useTypeSelector((state) => state);
    const isGuestUser = isGuest(auth);
    const isProfessionalUser = isProfessional(auth);
    // 詳細データ取得, ページ状態管理
    const { caseOneData, fetchCaseOne } = useCaseOneFetch({
        dispatch,
        unmountRef,
    });
    // ローディング中か（idに対応するデータがない＝undefinedの場合、強制的にデータ取得を行わせるためtrueを返す）
    const loading = ((_a = caseOneData === null || caseOneData === void 0 ? void 0 : caseOneData[id]) === null || _a === void 0 ? void 0 : _a.loading) === undefined ? true : caseOneData === null || caseOneData === void 0 ? void 0 : caseOneData[id].loading;
    // 表示中の詳細のデータ
    const currentCaseOneData = (_b = caseOneData === null || caseOneData === void 0 ? void 0 : caseOneData[id]) === null || _b === void 0 ? void 0 : _b.data;
    useEffect(() => {
        if (!currentCaseOneData) {
            ;
            (() => __awaiter(void 0, void 0, void 0, function* () {
                yield fetchCaseOne(id);
            }))();
        }
    }, [currentCaseOneData, fetchCaseOne, id]);
    // ローディング表示
    if (loading && !currentCaseOneData) {
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(CaseOneViewSkeleton, { isGuestUser: isGuestUser, isProfessionalUser: isProfessionalUser }) })));
    }
    // リダイレクト: id に一致するデータがない場合
    if (!currentCaseOneData) {
        return _jsx(CustomRedirect, { to: caseListPath() });
    }
    return (_jsx(CaseOnePage, { caseOneData: currentCaseOneData, isGuestUser: isGuestUser, isProfessionalUser: isProfessionalUser }));
};
